// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.el-margin[data-v-3b67e05d]{\n  margin: 0 10px 5px 5px;\n}\n", ""]);
// Exports
module.exports = exports;
